var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup25(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#F5F5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4829 22.697C21.6913 22.697 22.6709 21.7174 22.6709 20.509C22.6709 19.3006 21.6913 18.321 20.4829 18.321C19.2745 18.321 18.2949 19.3006 18.2949 20.509C18.2949 21.7174 19.2745 22.697 20.4829 22.697Z",
    fill: "#0A66C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7367 24.355V36.494H28.5057V30.491C28.5057 28.907 28.8037 27.373 30.7677 27.373C32.7047 27.373 32.7287 29.184 32.7287 30.591V36.495H36.4997V29.838C36.4997 26.568 35.7957 24.055 31.9737 24.055C30.1387 24.055 28.9087 25.062 28.4057 26.015H28.3547V24.355H24.7367V24.355ZM18.5947 24.355H22.3697V36.494H18.5947V24.355Z",
    fill: "#0A66C2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup25);
export default __webpack_public_path__ + "static/media/Group 25.fae64d5027a8224ce735f99dc4fd9bed.svg";
export { ForwardRef as ReactComponent };